import { Link } from 'react-router-dom';
import { Tooltip } from 'antd';
import Icons from 'components/icons';
import Events from 'components/events';
import Craft from 'components/craft';
import Stands from 'components/stands';
import { Localize } from 'components/service';
import { helperFunc } from 'utils'


const StandCraftsField = ({ stand, crafts }) => {


    const { charSplitToUpper } = helperFunc;
    const { craftColor, getIconCraft } = Craft.Helpers.Functions;
    const assignSubcontractors = crafts.filter(craft => craft?.subcontractor_id).length

    const {
        _setCraftCreateUpdate,
    } = Craft.Hooks.createUpdate({ craftID: true });

    // Crypt sorting function in a certain order
    const sortCrafts = (craftsList) => {
        return craftsList.sort((a, b) => {
            // Check if the craft has a custom icon
            const aHasIcon = !!a.type_icon;
            const bHasIcon = !!b.type_icon;

            // If both have an icon or both do not have an icon, leave as is
            if (aHasIcon === bHasIcon) {
                return 0;
            }

            // Craft with custom icon goes to the end
            if (aHasIcon) return 1;
            if (bHasIcon) return -1;

            return 0;
        });
    };

    const handleCraftClick = (craftType, currentStatus) => {

        let nextStatus;

        if (craftType === 'collect_graphics')
        {
            switch (currentStatus)
            {
                case 'open':
                    nextStatus = 'collected';
                    break;
                case 'collected':
                    nextStatus = 'done';
                    break;
                case 'done':
                    nextStatus = 'open';
                    break;
                default:
                    nextStatus = 'open';
            }
        } else
        {
            nextStatus = currentStatus === 'disabled' ? 'in_progress' : 'disabled';
        }

        return nextStatus;
    };

    // Sort crafts before rendering
    const sortedCrafts = sortCrafts([...crafts]);

    return (
        <>
            <ul className='crafts-list'>
                {
                    sortedCrafts?.map(craft =>
                        <li key={ +craft.id } onClick={ () => {
                            const nextStatus = handleCraftClick(craft?.type, craft?.status);

                            _setCraftCreateUpdate({
                                variables: {
                                    input: {
                                        id: craft?.id ? +craft?.id : undefined,
                                        stand_id: +craft?.stand_id,
                                        status: nextStatus
                                    }
                                }
                            });
                        } }>
                            <Tooltip overlayClassName="craft-tooltip" destroyTooltipOnHide={ true } title={ craft?.title }>
                                <span
                                    className={ `craft ${ craftColor(craft?.status) }` }>

                                    <span className='count'>
                                        { craft?.type.match(/\d+/) }
                                    </span>

                                    { getIconCraft(charSplitToUpper(craft?.type, '_', false), craft?.type_icon) }
                                </span>
                            </Tooltip>
                        </li>
                    )
                }
            </ul>

            {
                crafts.length ?

                    <Link
                        to={ `${ Events.Const.basePath }/${ stand?.ee_id }${ Stands.Const.basePath }/${ stand?.id }${ Craft.Const.basePath }` }
                        className='craft-assigned'
                    >

                        <span><Localize>GLOBAL.Link_Text_Assigned</Localize> { `${ assignSubcontractors }/${ crafts.length }` }</span>
                        <Icons.Arrow className='arrow-right' />
                    </Link> : <strong>&mdash;</strong>
            }

        </>

    );
};

export default StandCraftsField;
